import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useDocumentTitle(title?: string) {
  const { pathname } = useLocation();

  useEffect(() => {
    // Skip when title is undefined so the hook can run unconditionally in an
    // embedded context (e.g. the reconstructed-document peek modal) without
    // clobbering the host page's document.title.
    if (title !== undefined) setTitle(title);
  }, [title, pathname]);

  return { setTitle };

  function setTitle(title: string) {
    document.title = title + ' :: TRecs';
  }
}
